import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  // form: { display: "flex", flexWrap: "wrap" },
  // textField: { marginTop: theme.spacing(1), marginBottom: theme.spacing(1) },
  button: {
    textTransform: "none",
    "&:focus": {
      outline: "none",
    },
  },
}));

const CancelAlert = ({ modalOpen, modalClose, modalSave }) => {
  const classes = useStyles();

  return (
    <Dialog
      disableBackdropClick
      fullWidth
      maxWidth="xs"
      open={modalOpen}
      onClose={modalClose}
    >
      <DialogTitle> Cancel campaign creation </DialogTitle>
      <DialogContent dividers>
        <Typography variant="body1">
          Campaign have unsaved.Are you sure you want to leave this page ?
        </Typography>{" "}
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          color="primary"
          className={classes.button}
          onClick={modalSave}
        >
          Yes{" "}
        </Button>{" "}
        <Button
          variant="contained"
          className={classes.button}
          onClick={modalClose}
        >
          No{" "}
        </Button>{" "}
      </DialogActions>{" "}
    </Dialog>
  );
};

export default CancelAlert;
